import {Injectable} from '@angular/core';
import * as _ from 'lodash';
import * as jwt_decode from 'jwt-decode';
import {Observable} from 'rxjs';
import {BackendService} from '../../services/backend.service';
import {catchError} from 'rxjs/operators';
import {HttpHeaders} from '@angular/common/http';

@Injectable()
export class AuthService extends BackendService {

    login(username, password) {
        this._token = btoa(_.toLower(username) + ":" + password);
        return super.doLoad('auth/login')
    }

    checkAuth(token = this._token): Observable<any> {
        this._token = token;
        return super.doLoad('auth/check')
    }

    checkExternal(token): Observable<any> {
        return this.http.get<any>( this.apiUrl + 'shares/token/check', this.overrideTokenHeaderOptions(token))
            .pipe(
                catchError(this.handleError)
            );
    }

    logout(): Observable<any> {
        return super.doLoad('auth/logout')
    }

    decodeToken(token) {
        try {
            return jwt_decode(token);
        }
        catch (Error) {
            return null;
        }
    }

    protected overrideTokenHeaderOptions(token) {
        return {
            headers: new HttpHeaders({
                'Authorization': 'Bearer ' + token
            })
        };
    }
}
